import { createPortal } from "react-dom";
import { motion } from "framer-motion";

// Composant commun pour toutes les modales détaillées de la Centrale (candidatures, prospects, territoires, rappels...)
// Structure garantie en 3 zones : header fixe / corps scrollable / footer fixe, jamais plus haute que l'écran.
// Rendue via un Portal dans document.body avec un z-index très supérieur à Leaflet (panes/contrôles vont jusqu'à ~1000)
// pour ne jamais être recouverte par la carte, quels que soient les stacking contexts des parents.
export const AdminModalOverlay = ({ onClose, children, testId }) => createPortal(
  <motion.div
    data-testid={testId}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="fixed inset-0 z-[9999] flex items-end justify-center bg-navy/70 backdrop-blur-sm sm:items-center sm:p-6"
    onClick={onClose}
    onWheel={(e) => e.stopPropagation()}
  >
    {children}
  </motion.div>,
  document.body
);

export const AdminModalCard = ({ children, maxWidth = "max-w-lg" }) => (
  <motion.div
    initial={{ y: 50, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    exit={{ y: 50, opacity: 0 }}
    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    onClick={(e) => e.stopPropagation()}
    className={`flex max-h-[calc(100dvh-32px)] w-full ${maxWidth} flex-col overflow-hidden rounded-t-3xl bg-white sm:rounded-3xl`}
  >
    {children}
  </motion.div>
);

export const AdminModalBody = ({ children, className = "" }) => (
  <div
    data-lenis-prevent
    className={`min-h-0 flex-1 overflow-y-auto px-7 py-6 sm:px-9 ${className}`}
    style={{ WebkitOverflowScrolling: "touch", overscrollBehavior: "contain" }}
  >
    {children}
  </div>
);
